import {imgExtensions} from "../../../../../components/dropzone/dropzone.jsx";

export const isImageAttach = (attach) => {
    const type = (attach?.type ?? attach?.extension ?? "").toLowerCase();

    return type.startsWith("image/") || imgExtensions.includes(type);
};
